import updateGridView from "./update-grid-view";

let itemsBtnGrid = document.querySelector('.js-items-btn--grid');
let itemsBtnList = document.querySelector('.js-items-btn--list');
let itemsWrap = document.querySelector('.js-items-wrap');

if (itemsBtnGrid) {
    itemsBtnGrid.addEventListener('click', (e) => {

        itemsWrap.classList.remove('is-cards--horizontal', 'is-items-list');
        itemsWrap.classList.add('is-cards--vertical', 'is-items-grid');
        itemsBtnList.classList.add('btn-light-disabled');
        itemsBtnGrid.classList.remove('btn-light-disabled');
        // reload select2 boxes
        $.initSelect2();
        // update grid view
        updateGridView('grid');
    });
}

if (itemsBtnList) {
    itemsBtnList.addEventListener('click', (e) => {

        itemsWrap.classList.remove('is-cards--vertical', 'is-items-grid');
        itemsWrap.classList.add('is-cards--horizontal', 'is-items-list');
        itemsBtnGrid.classList.add('btn-light-disabled');
        itemsBtnList.classList.remove('btn-light-disabled');
        // reload select2 boxes
        $.initSelect2();
        // update list view
        updateGridView('list');
    });
}
